"use client";

import { useContext } from "react";
import { PlayIcon } from "lucide-react";
import { createPath } from "@/service/routing/routing";

import slugify from "slugify";
import { UserContext } from "@/contexts/user-context";
import { ExamPageTypeLink } from "@/components/exams/exam-page-type/link/exam-page-type-link";
import { ExamPageTypeStartDialog } from "@/components/exams/exam-page-type/questions/exam-page-type-start-dialog";
import { Button } from "@/components/ui/button";
import { ExamPageTypeTitle } from "@/components/exams/exam-page-type/exam-page-type-title";
import { ExamPageTypeContainer } from "@/components/exams/exam-page-type/exam-page-type-container";

export const ExamPageTypeListSpecializations = ({
  specializations,
  typeName,
  subtitle,
  pathname = "exam.page_type.specialization",
  title = "Egzamin",
  attemptPathname = null,
}: {
  specializations: { name: string; slug: string }[];
  typeName: ExamType;
  subtitle: string;
  pathname?: string;
  title?: string;
  attemptPathname?: string | null;
}) => {
  const { isLoggedIn } = useContext(UserContext);
  return (
    <div className="@container mx-auto max-w-[var(--content-width)]">
      <ExamPageTypeTitle
        showExamTypeSelector={typeName === "PES"}
        type={typeName}
        title={`${title} ${typeName} ${
          typeName === "PES" ? "" : "- wybierz dziedzinę"
        }`}
        isH1={typeName === "PES"}
      />
      <ExamPageTypeContainer
        title={subtitle}
        isH1={typeName !== "PES"}
        actions={
          attemptPathname ? (
            isLoggedIn ? (
              // Podejście z tej strony bierze całą bazę CEM, więc zestaw do przeglądania
              // składa się z tego samego źródła (`allCem`) — nie z pojedynczej dziedziny.
              <ExamPageTypeStartDialog
                attemptPathname={attemptPathname}
                params={{ type: typeName.toLowerCase() }}
                browseSources={{ allCem: true }}
                scope="database"
              >
                <Button variant={"blue"}>
                  <PlayIcon />
                  Ucz się z bazy pytań CEM
                </Button>
              </ExamPageTypeStartDialog>
            ) : (
              <Button asChild={true}>
                <a href={createPath("security.login")}>
                  Zaloguj się, aby rozpocząć podejście
                </a>
              </Button>
            )
          ) : null
        }
      >
        {specializations.map(({ name, slug }) => {
          return (
            <ExamPageTypeLink
              text={name}
              key={name}
              link={createPath(pathname, {
                type: slugify(typeName, { lower: true }),
                specialization: slug,
              })}
            />
          );
        })}
      </ExamPageTypeContainer>

      <div className={"mt-4"}>
        <Button
          variant={"outline"}
          onClick={() => {
            const { pathname } = window.location;
            window.location.pathname = pathname.substring(
              0,
              pathname.lastIndexOf("/"),
            );
          }}
        >
          Wróć
        </Button>
      </div>
    </div>
  );
};
